<template>
  <!-- <SpinnerComponent />
  <SuccessComponent />
  <ErrorComponent /> -->
  <div v-if="isVisible" class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-contact-info">
        <p class="title">Contáctanos</p>
        <p class="subtitle">¡Transformemos tu contenido en ventas!</p>
        <div class="wrapper-info">
          <div class="info">
            <img
              class="icon"
              src="assets/icons/Phone.svg"
              alt="Teléfono"
            />
            <p class="text-contact">3105456982 - 3155764999 - 3502149948</p>
          </div>
          <div class="info">
            <img
              class="icon"
              src="assets/icons/Email.svg"
              alt="Correo"
            />
            <p class="text-contact">creandoideas@artisticvisionstudio.com.co</p>
          </div>
          <div class="info">
            <img
              class="icon"
              src="assets/icons/Location.svg"
              alt="Ubicación"
            />
            <p class="text-contact">Bogotá, Cundinamarca</p>
          </div>
        </div>
      </div>
      <div class="wrapper-form">
        <img
          src="assets/icons/CloseBlack.svg"
          alt="Cerrar"
          class="close"
          @click="closeModal"
        />

        <div class="contact-wp">
          <p class="text-principal">Escríbenos por WhatsApp</p>
          <p class="text-secondary">Asesoría rápida y directa</p>
          <img
            src="assets/icons/WhatsappContact.svg"
            alt="whatsapp"
            class="icon-wp"
            @click="openWhatsApp"
          />
        </div>

        <!-- <div class="inputs">
          <div class="full">
            <GeneralInput
              :label="'Nombre'"
              v-model:text="name.val"
              :value="name.val"
              :has-error="name.enabled"
              :error="name.errors.length === 0 ? '' : name.errors[0]"
            />
          </div>
          <div class="part1">
            <GeneralInput
              :label="'Correo electrónico'"
              v-model:text="email.val"
              :value="email.val"
              :has-error="email.enabled"
              :error="email.errors.length === 0 ? '' : email.errors[0]"
            />
          </div>

          <div class="part2">
            <GeneralInput
              :label="'Teléfono / Whatsapp'"
              v-model:text="phone.val"
              :value="phone.val"
              :has-error="phone.enabled"
              :error="phone.errors.length === 0 ? '' : phone.errors[0]"
            />
          </div>

          <div class="full">
            <GeneralTextArea
              :label="'Mensaje'"
              v-model:text="message.val"
              :value="message.val"
              :has-error="message.enabled"
              :error="message.errors.length === 0 ? '' : message.errors[0]"
            />
          </div>
        </div>

        <GenericButton
          text="Enviar mensaje"
          backgroundColor="var(--black)"
          textColor="var(--white)"
          shadowType="dark"
          :is-disabled="successForm"
        /> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
// import GeneralInput from "@/components/commons/controls/GeneralInput.vue";
// import GeneralTextArea from "@/components/commons/controls/GeneralTextArea.vue";
// import { contactUsValidator } from "@/ux/sharedComponents/validators/contactUsValidator";
// import { contactUsUse } from "@/ux/sharedComponents/use/contactUsUse";
// import GenericButton from "../../components/commons/controls/GenericButton.vue";
// import SuccessComponent from "./SuccessComponent.vue";
// import ErrorComponent from "./ErrorComponent.vue";
// import SpinnerComponent from "@/components/spinner/SpinnerComponent.vue";

export default defineComponent({
  name: "ContactUsComponent",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // GeneralInput,
    // GeneralTextArea,
    // GenericButton,
    // SuccessComponent,
    // ErrorComponent,
    // SpinnerComponent,
  },

  setup(props, context) {
    // const { name, email, phone, message, successForm } = contactUsValidator();

    function closeModal() {
      context.emit("close");
    }

    function openWhatsApp() {
      window.open("https://wa.me/573105456982", "_blank");
    }

    return {
      closeModal,
      // name,
      // email,
      // phone,
      // message,
      // successForm,
      openWhatsApp,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedComponents/styles/contactUsStyle";
</style>
